import React, { useEffect, useState } from "react";
import "./affectedAppointmentsPopup.scss";
import { Dialog, Divider } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import close_icon from "../../../assets/crossIcon.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TitleSubtitleCard from "../../common/Modules/TitleSubtitleCard";
import moment from "moment";
import errorIcon from "../../../assets/errorIcon.svg";
import {
  GET_AFFECTED_APPOINTMENTS,
  MARK_DELAY_API,
} from "../DelayMarkingAPIHandler/APIconstants";
import NoData from "../../../assets/Nodata.svg";
import Loader from "../../../assets/C2C Loader.gif";
import swal from "sweetalert";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { c2cPostApiHandler } from "../../../Util/c2cApiHandler";

const styles = {
  dialogPaper: {
    width: "650px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 3px 6px #00000029",
    borderRadius: "10px",
  },
  mobileDialogPaper: {
    width: "92vw",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 3px 6px #00000029",
    borderRadius: "5px",
    margin: "0",
  },
};

const AffectedAppointmentsPopup = (props) => {
  const {
    classes,
    openPopup,
    scheduleId,
    consultationType,
    handleClosePopup,
    handleOpenPrevPopop,
    handleMarkDelaySuccess,
  } = props;

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const user_type = localStorage.getItem("user_type");

  const [appointmentsList, setAppointmentsList] = useState([]);
  const [endTime, setEndTime] = useState("");
  const [showError, setShowError] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  //  Lifecycle Methods ===>

  useEffect(() => {
    getAffectedAppointments();
  }, []);

  // <===

  // API Calls ===>

  const getAffectedAppointments = () => {
    setShowLoader(true);
    let payload = {
      delay_schedule_id: scheduleId,
    };
    let resData = c2cPostApiHandler(GET_AFFECTED_APPOINTMENTS, payload);
    resData.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          let cancelledAppnts = res.data.data.filter(
            (appnt) => appnt.suggested_status === "cancel"
          );
          if (cancelledAppnts.length !== 0) {
            setShowError(true);
            setEndTime(
              moment(
                res.data.data[res.data.data.length - 1].appointment_date +
                  "T" +
                  res.data.data[res.data.data.length - 1].suggested_end_time
              ).format("hh:mm A")
            );
          }
          setAppointmentsList(res.data.data);
          setShowLoader(false);
        }
      } else {
        setAppointmentsList([]);
        setShowLoader(false);
      }
    });
  };

  const handleMarkDelay = () => {
    setShowLoader(true);
    let payload = {
      data: appointmentsList,
      doctor_id: userId,
      staff_id: staffId,
      delay_schedule_id: scheduleId,
      user_type: user_type,
      clinic_id: clinicId,
    };
    let resData = c2cPostApiHandler(MARK_DELAY_API, payload);
    resData.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          setShowLoader(false);
          handleMarkDelaySuccess();
        } else {
          setShowLoader(false);
          swal({
            title: "Something went wrong",
            text: res?.data?.message,
            icon: "warning",
          });
        }
      }
    });
  };

  // <===

  // Display UI ===>

  const displayAffectedAppointmentsPopup = () => {
    return (
      <Dialog
        open={openPopup}
        classes={{
          paper:
            window.innerWidth > 767
              ? classes.dialogPaper
              : classes.mobileDialogPaper,
        }}
      >
        <div className="affected-appointments-popup">
          {displayAffectedAppointmentsPopupHeader()}
          <Divider />
          {displayAffectedAppointmentsPopupContent()}
          {displayAffectedAppointmentsPopupFooter()}
        </div>
      </Dialog>
    );
  };

  const displayAffectedAppointmentsPopupHeader = () => {
    return (
      <div className="affected-appointments-popup-header">
        <div className="affected-appointments-header">
          <span className="affected-appointments-header-value">
            Delay Marking &nbsp;
          </span>
          <div>
            for{" "}
            <span className="affected-appointments-header-consultation-type">
              {consultationType}
            </span>
          </div>
        </div>
        <div
          className="affected-appointments-popup-close"
          onClick={handleClosePopup}
        >
          {"Close"} <img src={close_icon} alt="" />
        </div>
      </div>
    );
  };

  const displayAffectedAppointmentsPopupContent = () => {
    return (
      <div className="affected-appointments-popup-content">
        <div className="affected-appointments-popup-content-title">
          <span style={{ flex: "1" }}>
            <ArrowBackIcon
              style={{ width: "18px", cursor: "pointer" }}
              onClick={handleOpenPrevPopop}
            />{" "}
            Affected Appointments
          </span>
          {window.innerWidth < 767 && showError && (
            <img
              src={errorIcon}
              alt=""
              className="affected-appointments-error-icon"
              style={{ margin: "0" }}
            />
          )}
        </div>
        {showError && (
          <div className="affected-appointments-error-msg">
            {window.innerWidth > 767 && (
              <img
                src={errorIcon}
                alt=""
                className="affected-appointments-error-icon"
              />
            )}
            <div>
              {
                "If you don’t wish to cancel your appointments, kindly change your end time to"
              }{" "}
              <b>{endTime}</b> {window.innerWidth > 767 && <br />}
              {"Or select mark delay to cancel these appointments."}
            </div>
          </div>
        )}
        <div className="affected-appointments-content">
          {window.innerWidth > 767 && displayAppointmentsHeader()}
          {showLoader ? (
            <div className="d-flex justify-content-center loader-div">
              <img src={Loader} alt="" className="" />
            </div>
          ) : (
            <>{displayAppointmentsContent()}</>
          )}
        </div>
      </div>
    );
  };

  const displayAppointmentsHeader = () => {
    return (
      <div className="affected-appointments-content-header">
        <div className="col-4">PATIENT DETAILS</div>
        <div className="col-4">{"OLD DATE & TIME"}</div>
        <div className="col-4">{"NEW DATE & TIME"}</div>
      </div>
    );
  };

  const displayAppointmentsContent = () => {
    return (
      <div className="affected-appointments-content-data">
        {appointmentsList?.length > 0 ? (
          <>
            {appointmentsList.map((appnt) => (
              <div
                key={appnt.appointment_id}
                className={
                  "affected-appointments-content-data-details " +
                  (window.innerWidth > 767
                    ? ""
                    : "affected-appointments-content-data-details-mobile-view")
                }
                style={{
                  borderColor:
                    window.innerWidth < 767 &&
                    appnt.suggested_status === "cancel"
                      ? "#DA1346"
                      : "",
                }}
              >
                <span
                  className={
                    "affected-appointments-patient-details " +
                    (window.innerWidth > 767
                      ? "col-4"
                      : "affected-appointments-mobile-view-content")
                  }
                  style={{ width: window.innerWidth < 767 ? "100%" : "" }}
                >
                  <span className="affected-appointments-mobile-view">
                    Patient details
                  </span>
                  <span
                    style={{
                      color:
                        window.innerWidth > 767 &&
                        appnt.suggested_status === "cancel"
                          ? "#ED0000"
                          : "",
                    }}
                  >
                    <TitleSubtitleCard
                      title={appnt.patient_name}
                      subtitle={appnt.phone_no}
                    />
                  </span>
                </span>
                <span
                  className={
                    "affected-appointments-datetime " +
                    (window.innerWidth > 767
                      ? "col-4 pl-2"
                      : "affected-appointments-mobile-view-content")
                  }
                  style={{ marginBottom: window.innerWidth > 767 ? "" : "0" }}
                >
                  <span className="affected-appointments-mobile-view">
                    {"Old Date & Time"}
                  </span>
                  <span
                    style={{
                      color:
                        window.innerWidth > 767 &&
                        appnt.suggested_status === "cancel"
                          ? "#ED0000"
                          : "",
                    }}
                  >
                    <TitleSubtitleCard
                      title={moment(appnt.appointment_date).format(
                        "MMM DD, YYYY"
                      )}
                      subtitle={moment(
                        appnt.appointment_date + "T" + appnt.original_start_time
                      ).format("hh:mm A")}
                    />
                  </span>
                </span>
                <span
                  className={
                    "affected-appointments-datetime " +
                    (window.innerWidth > 767
                      ? "col-4 pl-0"
                      : "affected-appointments-mobile-view-content")
                  }
                  style={{ marginBottom: window.innerWidth > 767 ? "" : "0" }}
                >
                  <span className="affected-appointments-mobile-view">
                    {"New Date & Time"}
                  </span>
                  <span
                    style={{
                      color:
                        window.innerWidth > 767 &&
                        appnt.suggested_status === "cancel"
                          ? "#ED0000"
                          : "",
                    }}
                  >
                    <TitleSubtitleCard
                      title={moment(appnt.appointment_date).format(
                        "MMM DD, YYYY"
                      )}
                      subtitle={moment(
                        appnt.appointment_date +
                          "T" +
                          appnt.suggested_start_time
                      ).format("hh:mm A")}
                    />
                  </span>
                </span>
              </div>
            ))}
          </>
        ) : (
          <div className="affected-appointments-no-data">
            <img src={NoData} alt="" className={"no-data-img"} />
            <div>
              <p className="heading">No Records Found</p>
              <p className="message">There are no appointments found</p>
            </div>
          </div>
        )}
      </div>
    );
  };

  const displayAffectedAppointmentsPopupFooter = () => {
    return (
      <div className="affected-appointments-footer">
        <div
          className="affected-appointments-footer-cancel-btn"
          onClick={handleOpenPrevPopop}
        >
          Cancel
        </div>
        <div
          className="affected-appointments-footer-mark-delay-btn"
          onClick={handleMarkDelay}
        >
          Mark Delay
        </div>
      </div>
    );
  };

  // <===

  return <>{displayAffectedAppointmentsPopup()}</>;
};

export default withStyles(styles)(AffectedAppointmentsPopup);
